import { combineReducers } from "redux-immutable";

import { makeCrudStateReducer } from "seneca-common/utils/apiStates";

import {
  courseDetailsCrudStateConfig,
  courseCrudStateConfig,
  courseSectionsCrudStateConfig,
  sectionCrudStateConfig
} from "../../../const";

const courseDetailsMetaReducer = makeCrudStateReducer(
  courseDetailsCrudStateConfig
);

const fullCourseMetaReducer = makeCrudStateReducer(courseCrudStateConfig);

const courseSectionsMetaReducer = makeCrudStateReducer(
  courseSectionsCrudStateConfig
);

const sectionMetaReducer = makeCrudStateReducer(sectionCrudStateConfig);

export default combineReducers({
  courseDetails: courseDetailsMetaReducer,
  fullCourses: fullCourseMetaReducer,
  courseSections: courseSectionsMetaReducer,
  section: sectionMetaReducer
});
